<form [formGroup]="cargueForm" class="card">
  <div class="card-header">
    <b>Carga Masiva de Cuentas Bloqueadas</b>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-6 col-12 mb-3">
        <button type="button" mat-button class="secondary w-100" (click)="inputFile.click()">
          Seleccionar archivo
        </button>
        <input type="file" accept=".csv" (change)="onSelectFile(inputFile)" #inputFile hidden/>
      </div>
      <div class="col-md-6 col-12 mb-3">
        <button [disabled]="!isFileLoaded" (click)="onSubmit()" mat-button class="primary w-100">
          Subir Archivo
        </button>
      </div>
    </div>
  </div>
  <div class="card-footer gap-1">
  </div>
</form>

<!-- Tabla de cuentas bloqueadas -->
<div class="card mt-4">
  <div class="card-header">
    <b>Cuentas Bloqueadas</b>
  </div>
  <div class="card-body p-0">
    <div class="px-3 py-2" *ngIf="cuentasBloqueadas.length > 0">
      <div class="row align-items-center mb-3">
        <div class="col-md-6 col-12 mb-2 mb-md-0">
          <input type="text" class="form-control form-control-sm" style="color: #212529;" placeholder="Buscar por cédula, cuenta, factura o nombre..." [(ngModel)]="searchTerm" (input)="onSearch()">
        </div>
        <div class="col-md-6 col-12">
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">Total: {{filteredCuentas.length}} registros</small>
            <div class="d-flex align-items-center">
              <label class="mr-2 mb-0 small" for="pageSizeSelect">Por página:</label>
              <select id="pageSizeSelect" class="form-control form-control-sm" style="width: 70px;" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
                <option *ngFor="let size of [5,10,20,30]" [value]="size">{{size}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped mb-0">
        <thead class="thead-light" style="background-color: #050505;">
        <tr>
          <th class="d-none d-md-table-cell">#</th>
          <th>Cédula</th>
          <th class="d-none d-sm-table-cell">Cuenta</th>
          <th>Factura</th>
          <th class="d-none d-lg-table-cell">Nombre</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let cuenta of filteredCuentas | slice:(currentPage-1)*pageSize:(currentPage)*pageSize; let i = index">
          <td class="d-none d-md-table-cell">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
          <td>
            <div class="font-weight-bold">{{ cuenta.N_IDE }}</div>
            <small class="text-muted d-sm-none">{{ cuenta.CUE }}</small>
          </td>
          <td class="d-none d-sm-table-cell">{{ cuenta.CUE }}</td>
          <td>
            <div class="font-weight-bold">{{ cuenta.N_ORI }}</div>
            <small class="text-muted d-lg-none">{{ (cuenta.NOMBRE || '') | slice:0:20 }}{{ (cuenta.NOMBRE || '').length > 20 ? '...' : '' }}</small>
          </td>
          <td class="d-none d-lg-table-cell">{{ cuenta.NOMBRE }}</td>
          <td>
            <span class="badge badge-danger">Bloqueada</span>
          </td>
          <td>
            <button class="btn btn-sm primary" style="padding: 2px 6px; font-size: 9px; min-width: auto; height: 18px; line-height: 1; border: none; white-space: nowrap;" (click)="desbloquearCuenta(cuenta)">
              Liberar
            </button>
          </td>       
        </tr>
        <tr *ngIf="filteredCuentas.length === 0 && cuentasBloqueadas.length > 0">
          <td colspan="7" class="text-center py-4">No se encontraron resultados para la búsqueda.</td>
        </tr>
        <tr *ngIf="cuentasBloqueadas.length === 0">
          <td colspan="7" class="text-center py-4">No hay cuentas bloqueadas cargadas.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav *ngIf="filteredCuentas.length > pageSize" class="mt-3">
      <ul class="pagination justify-content-center mb-0 pagination-sm">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <button class="page-link" style="color: #212529;" (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">&laquo;</button>
        </li>
        <li 
          class="page-item d-none d-sm-block" 
          *ngFor="let page of pagesArray; let idx = index"
          [class.active]="currentPage === idx + 1"
        >
          <button class="page-link" style="color: #212529;" (click)="currentPage = idx + 1">{{ idx + 1 }}</button>
        </li>
        <li class="page-item d-sm-none">
          <span class="page-link" style="color: #212529; background: transparent; border: none;">{{currentPage}} / {{totalPages}}</span>
        </li>
        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <button class="page-link" style="color: #212529;" (click)="currentPage = currentPage + 1" [disabled]="currentPage === totalPages">&raquo;</button>
        </li>
      </ul>
    </nav>
  </div>
</div>

<style>
  .pagination .page-link {
    color: #e2e7ec !important;
    font-weight: 600;
    background: #fff;
    border: 1px solid #dee2e6;
  }
  .pagination .page-item.active .page-link {
    background: #e9ecef;
    color: #212529 !important;
    border-color: #adb5bd;
  }
  #pageSizeSelect,
  #pageSizeSelect option {
    color: #212529 !important;
    background: #fff !important;
    font-weight: 600;
  }
  
  @media (max-width: 576px) {
    .card-header {
      font-size: 14px;
      text-align: center;
    }
    
    .table td, .table th {
      padding: 0.5rem 0.25rem;
      font-size: 12px;
    }
    
    .btn {
      font-size: 11px !important;
      padding: 1px 3px !important;
    }
    
    .pagination-sm .page-link {
      padding: 0.25rem 0.5rem;
      font-size: 0.75rem;
    }
  }
  
  @media (max-width: 768px) {
    .table-responsive {
      border: none;
    }
  }
</style>
